import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";

export interface CheckMeta {
  slug: string;
  name: string;
  category: string;
  urlTypes: string[];
  requiresBrowser: boolean;
  defaultParams: Record<string, unknown>;
  description: string;
}

export function useChecksCatalog() {
  return useQuery({
    queryKey: ["checks-catalog"],
    queryFn: async () => {
      const { data } = await api.get<CheckMeta[]>("/checks/catalog");
      return data;
    },
    staleTime: Infinity,
  });
}
